module.exports = __webpack_public_path__ + "static/media/lyrics.63e222ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/lyrics.png
// module id = 91
// module chunks = 0